import React from 'react';

// Shown briefly right after an interactive login (not on silent session
// restore — see QuizAdminStatusProvider.js), then fades out to reveal the
// landing page. Pure presentational, auto-dismissed by the parent's timer.
export default function SplashScreen() {
  return (
    <div className="splashScreen">
      <div className="splashScreenContent">
        <img src="/favicon.ico" className="splashScreenLogo" alt="" />
        <div className="splashScreenTitle">BOMBAB QUIZ</div>
      </div>
    </div>
  );
}
